<template>
  <div>
    <div class="product-add">
      <!--form表单-->
      <el-form ref="form" :model="form" size="small" label-width="150px">
        <div class="common-form">分销等级</div>
        <el-form-item label="分销等级" prop="agent_type" :rules="[{required: true,message: '请输入分销等级'}]">
          <el-radio-group v-model="form.agent_type">
            <el-radio label="1">一级分销</el-radio>
            <el-radio label="2">二级分销</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分销等级" prop="is_fixed_scale" :rules="[{required: true,message: '请输入分销等级'}]">
          <el-radio-group v-model="form.is_fixed_scale">
            <el-radio label="1">使用推广等级比例</el-radio>
            <el-radio label="2">固定比例</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="一级技师比例" prop="one_waiter_scale" :rules="[{required: true,message: '一级技师比例不可为空'}]">
          <el-input v-model="form.one_waiter_scale" type="number" placeholder="填写一级技师比例" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="二级技师比例" prop="two_waiter_scale" :rules="[{required: true,message: '二级技师比例不可为空'}]">
          <el-input v-model="form.two_waiter_scale" type="number" placeholder="填写二级技师比例" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="一级用户比例" prop="one_user_scale" :rules="[{required: true,message: '一级用户比例不可为空'}]">
          <el-input v-model="form.one_user_scale" type="number" placeholder="填写一级用户比例" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="二级用户比例" prop="two_user_scale" :rules="[{required: true,message: '二级用户比例不可为空'}]">
          <el-input v-model="form.two_user_scale" type="number" placeholder="填写二级用户比例" class="max-w460"></el-input>
        </el-form-item>

      </el-form>
    </div>
    <div class="common-button-wrapper">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </div>
  </div>
</template>
<script>
import PromotionApi from "@/api/promotion.js";
export default {
  data() {
    return {
      form: {
        agent_type: "",
        is_fixed_scale: "",
        one_waiter_scale: "",
        two_waiter_scale: "",
        one_user_scale: "",
        two_user_scale: ""
      }
    };
  },
  created() {
    this.getDate();
  },
  methods: {
    getDate() {
      PromotionApi.setperson({}, true)
        .then(res => {
          this.form = res.data
        })
        .catch(err => {});
    },
    onSubmit() {
      let self = this;
      let params = {};
      params = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          PromotionApi.Psetperson(params, true)
            .then(res => {
              this.$message({
                message: res.msg,
                type: "success"
              });
            })
            .catch(err => {
              this.$message({
                message: err.msg,
                type: "warning"
              });
            });
        }
      });
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/promotion/setperson/index.vue